// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IiUD","col":"styles_col__2iPNA"};